export default __webpack_public_path__ + "static/media/hindi-card-bg.e84656dd.svg";